<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/mypage/account">アカウント情報</router-link></li>
                <li class="breadcrumb-item">APIトークン</li>
            </ol>
        </nav>
        <div class="container">
            <legend>
                APIトークン
            </legend>
            <div class="py-3">
                <p>
                    APIトークンを生成します。
                    生成したAPIトークンは一度しか表示されません。
                    コピーしてすぐに使用先のアプリに設定するか、安全なファイルに保存してください。
                    APIトークンはパスワードと同等に厳重に管理してください。
                    <span class="text-danger">「トークン生成」を行うと、既存のトークンは上書きされます。</span>
                </p>
                <p>
                    APIはエンジニア用の機能です。
                    トークンを取得したご自身の小説作品情報を、APIで取得することができます。
                    詳細はヘルプマニュアルの開発情報を御覧ください。
                </p>
            </div>
            <div class="form-group" v-if="token">
                <input type="text" v-model="token" id="api-token" class="form-control form-control-lg text-center" readonly @focus="copy">
            </div>
            <div class="form-group">
                <button type="button" class="btn btn-lg btn-block" :class="{
                    'btn-primary': !token,
                    'btn-warning': token
                }" @click="generateToken()">
                    <i class="fas fa-key"></i>
                    <span v-if="token">トークン再生成</span>
                    <span v-else>トークン生成</span>
                </button>
            </div>
            <div class="mt-5 text-center">
                <router-link to="/mypage/account">戻る</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>

<script>
export default {
    data() {
        return {
            user: {},
            token: null,
        }
    },
    methods: {
        generateToken() {
            axios.post("/mypage/user/api-token/generate").then(res => {
                this.token = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        copy() {
            if (!navigator.clipboard) {
                $(`#api-token`).select();
                document.execCommand("copy");
                alert.msg("APIトークンをコピーしました。");
            } else {
                navigator.clipboard.writeText(this.token).then(() => {
                    alert.msg("APIトークンをコピーしました。");
                }).catch(err => { alert.err(err) });
            }
        }
    },
    mounted() {
    }
}
</script>